export function parseDateValue(value: string | null | undefined): Date | null {
  if (!value) return null;
  // YYYY-MM-DD → als lokales Datum parsen (kein UTC-Offset)
  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (iso) {
    return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
  }
  // dd.MM.yyyy oder d.M.yyyy (Mobile-App und Nutzereingabe)
  const german = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(value);
  if (german) {
    return new Date(Number(german[3]), Number(german[2]) - 1, Number(german[1]));
  }
  // Legacy ISO-Timestamps (z.B. 2026-05-01T22:00:00.000Z) → JS konvertiert UTC→lokal korrekt
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function serializeDateValue(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
